import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ConversionList from './ConversionList';
import { actions } from './ConversionList.actions';
import {
    mainSelector,
    getHeaderName,
    getTotalPages,
    getTotalItems
} from './ConversionList.selectors';
import {
    getConversionStatuses,
    getActionTypes,
    getActionNames
} from '../../../../selectors/index';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderName,
    list: mainSelector,
    statuses: getConversionStatuses,
    actionTypes: getActionTypes,
    actionNames: getActionNames,
    totalPages: getTotalPages,
    totalItems: getTotalItems,
});

const ConversionListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            page: state.conversions.page,
            totalPages: state.conversionsTotal.totalPages,
            totalItems: state.conversionsTotal.totalItems,
            loading: state.conversionsTotal.loading || state.conversions.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getConversions: actions.getConversions,
            getTotalRows: actions.getTotalRows,
            onAddPostback: actions.onAddPostback.bind(actions)
        };
    }
)(withRouter(ConversionList));

export default ConversionListComponent;
